import Modal from "../../common/ModalPopup";
import { useEffect, useState } from "react";
import Select from 'react-select';
import { useDispatch, useSelector} from 'react-redux';
import { getMasterConfig } from '../../store/slices/common';
import FullPageLoader from "@common/FullPageLoader";
import moment from "moment";
import { updateFollowupStatus } from "../../../src/store/slices/insurance";
import { useParams } from 'react-router-dom';
import { fetchLeadProcessingDetails } from '../../store/slices/insurance';
import DatePicker from "react-datepicker";
import { LEAD_LOST_ID } from '../../config/constant';



const FollowUpPopup = (props: any) => {
    const [errors, setError] = useState<any>({});
    const [formData, setFormData] = useState<any>({status : 1});
	const [loading, setLoading] = useState(false);
    const queryParams = useParams();
    const dispatch: any = useDispatch();
    const commonState = useSelector((state: any) => state.common);

    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
    }, [commonState.common, dispatch]);
    
    const statusValues = props.showLostStatus ? commonState.common?.followup_status || [] : commonState.common?.followup_status.filter((item: { value: number; label: string }) => item.value !==  LEAD_LOST_ID);    
    
    const handleChange = async (event:any, key:string) => {
		if(key === 'followup_status'){
            formData[key] = event.value;
            formData['followup_status_name'] = event.label;
        } else if (key === 'comments') {
            formData[key] = event.target.value;
        } else if (key === 'followup_date') {
             const selectedDate = new Date(event);
            const now = new Date();
            if (isNaN(selectedDate.getTime())) {
                console.log("herr");
                formData[key] = null;
            } else {
                let minTime: Date;
                if (selectedDate.toDateString() === now.toDateString()) {
                    // Round current time to next 5-minute interval
                    const minutes = now.getMinutes();
                    const roundedMinutes = Math.ceil(minutes / 5) * 5;
                    minTime = new Date(now);
                    minTime.setMinutes(roundedMinutes, 0, 0);
                } else {
                    minTime = new Date(selectedDate);
                    minTime.setHours(0, 0, 0, 0); // start of day for future dates
                }
                // If time is 00:00 (only date selected), set to minTime
                if (selectedDate.getHours() === 0 && selectedDate.getMinutes() === 0) {
                    selectedDate.setHours(minTime.getHours(), minTime.getMinutes(), 0, 0);
                }
                formData[key] = moment(selectedDate).format("YYYY-MM-DD HH:mm");
            }
        }
		errors[key] = '';
		setError({ ...errors });
        setFormData({ ...formData });

	}

	const isFormValid = (formData : any) => {
		let isValid = true;
		if (!formData.followup_status || formData.followup_status === '') {
			errors['followup_status'] = 'This Field is Required';
			isValid = false;
		}

        if (!formData.followup_date || formData.followup_date === '') {
			errors['followup_date'] = 'This Field is Required';
			isValid = false;
		}

		if(formData && formData.comments && (formData.comments.split('').length < 3 || formData.comments.split('').length > 500)){
			errors['comments'] = 'Comments should be between 3 to 500';
			isValid = false;
		}
		setError({ ...errors });
		return isValid;

	}
  

	const changeFollowupStatus = async (e:any) => {
        if(isFormValid(formData)) {
            setLoading(true);
            const payload = {
                followup_status: formData.followup_status,
                followup_date: formData.followup_date,
                followup_status_name: formData.followup_status_name,
                comments: formData.comments,
                lead_id: +props.leadId,
                lead_hash_id:queryParams?.id
            };
            const response: any = await updateFollowupStatus(payload);

            setLoading(false);
            if (response && response.status === 200) {
                props.showFollowupPopup(false);
                 
                if (queryParams?.id) {
                    if (+formData.followup_status === LEAD_LOST_ID) {
                        props.reloadApi();
                    }
                    setLoading(true);
                    dispatch(fetchLeadProcessingDetails({ id: queryParams?.id }))
                        .finally(() => setLoading(false));
                }
            } else {
            }
        }
	}

    return (

        <div className="view-timeline-popup image-timeline-popup">
            <FullPageLoader show={loading} />
            <Modal show={props.followUpPopup} handleClose={() => props.showFollowupPopup(false)} >
                <div className="modal-header">
                    <h2>Mark Status & Follow-up</h2>
                </div>
                <div className="modal-body" >
                    <div className="row">
                        <div className="col-md-12">
                            <fieldset className="single-select">
                                <div className="material">
                                    <Select
                                        id="followup_status"
                                        className='react-select'
                                        onChange={(e: any) => handleChange(e, "followup_status")}
                                        options={statusValues}
                                        name="followup_status"
                                        placeholder={"Change Status"}
                                        value={statusValues.filter((e: any) => e.value === formData.followup_status)}
                                    />
                                </div>
                                <span className="error-txt">
                                    {errors.followup_status || ""}
                                </span>
                            </fieldset>
                        </div>
                        <div className="col-md-12">
                            <fieldset className="single-select followup-datepicker">
                                <div className="material">
                                    <div className={`datepicker`}>
                                        <DatePicker
                                           selected={
                                            formData?.followup_date &&
                                            new Date(formData.followup_date).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
                                                ? new Date(formData.followup_date)
                                                : null
                                            }
                                            onChange={(e) => handleChange(e, 'followup_date')}
                                            showTimeSelect
                                            timeIntervals={5}
                                            minDate={new Date()} 
                                            minTime={
                                                formData?.followup_date
                                                ? new Date(formData.followup_date).toDateString() === new Date().toDateString()
                                                    ? new Date() // disable past times for today
                                                    : new Date(new Date().setHours(0, 0, 0, 0)) // future date, full day
                                                : new Date() // nothing selected → assume today, disable past times
                                            }
                                            maxTime={new Date(new Date().setHours(23, 55, 0, 0))}
                                            dateFormat="dd MMM, yyyy h:mm aa"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="Follow-up Date"
                                            onKeyDown={(e) => e.preventDefault()}
                                        />
                                    </div>
                                </div>
                                 <span className="error-txt">
                                    {errors.followup_date || ""}
                                </span>
                            </fieldset>
                        </div>
                        <div className="col-md-12">
                            <fieldset className="">
                                    <div className="material">
                                        <textarea id="comments" rows={8}  placeholder=" " name="comments" className="form-input textarea-height" value={formData.comments} onChange={(e) => handleChange(e, "comments")}/>
                                        <label data-label= 'Comments' className="form-label"></label>
                                        <span className="error-txt">
                                            {errors.comments || ""}
                                        </span>
                                    </div>
                                </fieldset>
                        </div>

                        <div className="col-md-12">
                            {                                
                                <button className="btn-primary m-md-t" onClick={(e:any) => changeFollowupStatus(e)}>Update</button>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </div>

    )

}
export default FollowUpPopup;